<template>
    <div class="width100">
        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="2"></Aide>

        <h3 class="titreSolu text-center">Carte véhicule</h3>

        <h3 class="titreSolu text-center" v-if="niveau==1">De quelle type de véhicule s'agit il?</h3>
        <h3 class="titreSolu text-center" v-if="niveau==2">De quelle véhicule s'agit il?</h3>
        <h3 class="titreSolu text-center" v-if="niveau==3">Cliquez sur l'icone PDF pour ouvrir le document de  .</h3>

        <br />
        <div class="container text-center afficheCarte" v-if="vehiculeChoisi!=null&&niveau==2">
            <div class="row">
                <div class="col-12">
                    <h3><span class="badge bg-secondary">{{vehiculeChoisi.nomVehicule}}</span></h3>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <a v-if="vehiculeChoisi.CG" :href="vehiculeChoisi.CG" download="download" target="_blank">
                        <div v-if="vehiculeChoisi.CG" class="alert alert-success text-center" role="alert">
                            <b class="text-success">Carte grise </b><i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                        </div>
                    </a>
                    <div v-else class="alert alert-danger text-center" role="alert">
                        <b class="text-danger">Carte grise </b><i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                    </div>
                </div>
                <div  class="col-4">
                    <a v-if="vehiculeChoisi.CV" :href="vehiculeChoisi.CV" download="download" target="_blank">
                        <div v-if="vehiculeChoisi.CV" class="alert alert-success text-center" role="alert">
                            <b class="text-success">Carte verte  </b><i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                        </div>
                    </a>
                    <div v-else class="alert alert-danger text-center" role="alert">
                        <b class="text-danger">Carte verte </b><i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                    </div>
                </div>
                <div  class="col-4" v-if="typeVehicule==2">
                    <a v-if="vehiculeChoisi.ATP" :href="vehiculeChoisi.ATP" download="download" target="_blank">
                        <div v-if="vehiculeChoisi.ATP" class="alert alert-success text-center" role="alert">
                            <b class="text-success">Carte ATP  </b><i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                        </div>
                    </a>
                    <div v-else class="alert alert-danger text-center" role="alert">
                        <b class="text-danger">Carte ATP </b><i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                    </div>
                </div>
                <div  class="col-4" v-if="typeVehicule==1">
                    <a v-if="vehiculeChoisi.CT" :href="vehiculeChoisi.CT" download="download" target="_blank">
                        <div v-if="vehiculeChoisi.CT" class="alert alert-success text-center" role="alert">
                            <b class="text-success">Assurance  </b><i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                        </div>
                    </a>
                    <div v-else class="alert alert-danger text-center" role="alert">
                        <b class="text-danger">Assurance </b><i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <br />
        <br />
        <div v-if="niveau == 1" class="row" style="overflow: scroll;height:250px;">
            <div class="colSolu col-md-12 col-lg-4">
                <div class="thtab userList col-12 text-center rounded"
                      @click="choixTypeVehicule(1)">
                    Tracteur
                </div>
            </div>
            <div class="colSolu col-md-12 col-lg-4">
                <div class="thtab userList col-12 text-center rounded"
                      @click="choixTypeVehicule(2)">
                    Remorque
                </div>
            </div>
            <div class="colSolu col-md-12 col-lg-4">
                <div class="thtab userList col-12 text-center rounded"
                      @click="choixTypeVehicule(3)">
                    Voiture
                </div>
            </div>
        </div>
        <div v-if="niveau == 2" class="row" style="overflow: scroll;height:250px;">
            <div v-for="(vehicule, keyMachine) in listVehi" :key="keyMachine" class="colSolu col-md-12 col-lg-4">
                <div  class="thtab userList col-12 text-center rounded"
                      @click="choixVehicule(vehicule)">
                    {{vehicule.nomVehicule}}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center">
                <button v-if="niveau>1" class="btn btn-danger" block @click="returnEnArriere()">Retour</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CarteVehicule",
        props: ['token', 'site', 'user', 'racine', 'listUser', 'userId', 'userType', 'idUser', 'systemeClient', 'systemeClientId'
            , 'ifAppli'],
        data() {
            return {
                aide: '', errors: [], listMachine: null, choix: 0, niveau: 1, machine: null,carteGrisePdf:null,
                fileName:null,carteVertePdf:null,carteATPPdf:null,errorsCG: [],errorsCV: [],errorsATP: [],
                listVehi:null,vehiculeChoisi:null,typeVehicule:null
            };
        },
        methods: {
            tokenValide(json) {
                if (json['status'] == '401') {
                    this.$emit('token')
                }
            },
            returnEnArriere()
            {
                this.niveau--
                this.vehiculeChoisi=null
                this.listVehi=null
                this.typeVehicule=null
                console.log(this.vehiculeChoisi)
            },
            choixTypeVehicule(typeVehi)
            {
                fetch(this.racine + this.site + 'api/get_liste_vehicule_lingevres_by_type/'+typeVehi, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)

                    response.json().then(json => {

                        console.log(json)

                        this.listVehi = json['listeVehiculeCarte']
                        console.log(this.listVehi)
                        this.niveau = 2
                        this.typeVehicule = typeVehi
                    })
                })
            },
            choixVehicule(vehicule)
            {
                console.log(vehicule)
                this.vehiculeChoisi = vehicule
            }

        },
        mounted() {

        }
    }
</script>


<style scoped>
    .userList {
        padding: 5px;
        /*margin-left: 2px;
        margin-right: 2px;
        margin-top: 5px;*/
        border: 2px white solid;
        font-size: 28px;
    }

    .listMachineNonCharge {
        font-size: 28px;
    }
    .afficheCarte
    {
        margin-bottom: 50px;
        border: 3px solid #0f6674;
    }
</style>